<template>
    <div>
        <CCard color="light">
            <CCardHeader>
                <div class="ch-header">
                    <div style="width:100%">
                        <el-alert center :closable="false" :title="$t('VirtualCard.CardHolderPage.CardHolderListTip')" type="warning"></el-alert>
                    </div>
                    <div>
                        <el-button @click="openCardHolderDialog" class="create-holder-btn">{{ $t('VirtualCard.CardHolderPage.CreateCardHolder') }}</el-button>
                    </div>
                </div>
            </CCardHeader>
            <CCardBody>
                <el-table :data="items" style="width: 100%">
                    <template slot="empty">
                        <div style="margin: 3rem 0">
                        <h2>
                            No items
                            <CIcon
                            name="cilBan"
                            style="color: #e53535; width: 30px; height: 30px"
                            />
                        </h2>
                        </div>
                    </template>
                    <el-table-column align="center" prop="holder_name" :label="$t('VirtualCard.CardHolderPage.HoderName')"></el-table-column>
                    <el-table-column align="center" prop="birthday" :label="$t('VirtualCard.CardHolderPage.Birthday')"></el-table-column>
                    <el-table-column align="center" prop="country_code" :label="$t('VirtualCard.CardHolderPage.Country')"></el-table-column>
                    <el-table-column align="center" prop="state" :label="$t('VirtualCard.CardHolderPage.State')"></el-table-column>
                    <el-table-column align="center" prop="zipcode" :label="$t('VirtualCard.CardHolderPage.PostalCode')"></el-table-column>
                    <el-table-column align="center" prop="city" :label="$t('VirtualCard.CardHolderPage.City')"></el-table-column>
                    <el-table-column align="center" prop="address" :label="$t('VirtualCard.CardHolderPage.Address')"></el-table-column>
                    <el-table-column align="center" :label="$t('VirtualCard.Operation')">
                        <template slot-scope="scope">
                            <div>
                                <el-button v-if="!useSelect" @click="handleRemoveCardHolder(scope.row)" size="small" type="danger">{{ $t('VirtualCard.CardHolderPage.Remove') }}</el-button>
                                <el-button v-else class="create-holder-btn" @click="handleSelectCardHolder(scope.row)" size="small">{{ $t('VirtualCard.Create.CardHolderSelect') }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </CCardBody>
            <CCardFooter>
                <el-pagination
                background
                layout="prev, pager, next"
                :total="page_total"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="page_size"
                @current-change="handerPage"
                @size-change="handleSizeChange"
                >
                </el-pagination>
            </CCardFooter>
        </CCard>
        <!-- 创建持卡人窗口 -->
        <el-dialog append-to-body :close-on-click-modal="false" custom-class="create-card-holder-dialog" width="30%" :title="$t('VirtualCard.CardHolderPage.CreateCardHolder')" :visible.sync="dialogFormVisible">
            <el-form :model="cardHolderForm" :rules="cardHolderRulesForm" ref="ruleCardHolderForm" class="row g-3 demo-ruleForm">
                <CCol md="6">
                    <el-form-item required :label="$t('VirtualCard.CardHolderPage.FirstName')" prop="first_name">
                        <el-input v-model="cardHolderForm.first_name"></el-input>
                        
                    </el-form-item>
                </CCol>
                <CCol md="6">
                    <el-form-item required :label="$t('VirtualCard.CardHolderPage.LastName')" prop="last_name">
                        <el-input v-model="cardHolderForm.last_name"></el-input>
                        
                    </el-form-item>
                </CCol>
                <CCol md="6">
                    <el-form-item required :label="$t('VirtualCard.CardHolderPage.Birthday')" prop="birthday">
                
                        <el-date-picker value-format="yyyy-MM-dd" style="width:100%" v-model="cardHolderForm.birthday" type="date" placeholder="2025-01-01"></el-date-picker>
                        <p style="margin:0;font-size:11px;font-weight:bold;line-height:1.5;">{{ $t('VirtualCard.CardHolderPage.BirthdayTipMessage') }}</p>
                
                    </el-form-item>
                </CCol>
                <CCol md="6">
                    <el-form-item required :label="$t('VirtualCard.CardHolderPage.Country')" prop="country">
                            <el-select filterable style="width:100%" v-model="cardHolderForm.country" placeholder="">
                                <el-option
                                    v-for="(item,index) in sortBillingAdrOptions"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                            
                    </el-form-item>
                </CCol>
                <CCol md="6">
                    <el-form-item required :label="$t('VirtualCard.CardHolderPage.State')" prop="state">
                        <el-input v-model="cardHolderForm.state"></el-input>
                        <p style="margin:0;font-size:11px;font-weight:bold;line-height:1.5;">{{ $t('VirtualCard.CardHolderPage.StateTipMessage') }}</p>
                    </el-form-item>
                    
                </CCol>
                <CCol md="6">
                    <el-form-item required :label="$t('VirtualCard.CardHolderPage.City')" prop="city">
                        <el-input v-model="cardHolderForm.city"></el-input>
                        
                    </el-form-item>
                </CCol>
                <CCol md="6">
                    <el-form-item required :label="$t('VirtualCard.CardHolderPage.Address')" prop="address">
                        <el-input v-model="cardHolderForm.address" maxlength="40" show-word-limit></el-input>
                        <p style="margin:0;font-size:11px;font-weight:bold;line-height:1.5;">{{ $t('VirtualCard.CardHolderPage.AddressTipMessage') }}</p>
                    </el-form-item>
                </CCol>
                <CCol md="6">
                    <el-form-item required :label="$t('VirtualCard.CardHolderPage.PostalCode')" prop="zip">
                        <el-input v-model="cardHolderForm.zip"></el-input>
                        
                    </el-form-item>
                </CCol>

            </el-form>
            <!-- <CForm class="row g-3 needs-validation">
                <CCol md="6">
                    <CInput
                    feedback="Please provide a valid city."
                    id="validationFirstName"
                    invalid
                    required
                    >
                    <template #label>
                        <label>
                            <sup style="color:red;font-size: 14px;vertical-align: bottom;">*</sup>
                            {{$t('VirtualCard.CardHolderPage.FirstName')}}
                        </label>
                    </template>
                    </CInput>
                </CCol>
                <CCol md="6">
                    <CInput
                    feedback="Please provide a valid city."
                    id="validationLastName"
                    invalid
                    required
                    >
                    <template #label>
                        <label>
                            <sup style="color:red;font-size: 14px;vertical-align: bottom;">*</sup>
                            {{$t('VirtualCard.CardHolderPage.LastName')}}
                        </label>
                    </template>
                    </CInput>
                </CCol>
                <CCol md="6">
                    <div class="mgr-16">
                        <label>
                            <sup style="color:red;font-size: 14px;vertical-align: bottom;">*</sup>
                            {{ $t('VirtualCard.CardHolderPage.Birthday') }}</label>
                        <el-date-picker id="validationBirthday" required style="width:100%" v-model="cardHolderForm.birthday" type="date" placeholder="2025-01-01"></el-date-picker>
                    </div>
                </CCol>
                <CCol md="6">
                    <div class="mgr-16">
                        <label>
                            <sup style="color:red;font-size: 14px;vertical-align: bottom;">*</sup>
                            {{ $t('VirtualCard.CardHolderPage.Country') }}</label>
                        <el-select id="validationCountry" required filterable style="width:100%" v-model="cardHolderForm.country" placeholder="">
                        <el-option
                            v-for="(item,index) in sortBillingAdrOptions"
                            :key="index"
                            :label="item"
                            :value="item">
                        </el-option>
                        </el-select>
                    </div>
                </CCol>
                <CCol md="6">
                    <CInput
                    feedback="Please provide a valid city."
                    id="validationState"
                    invalid
                    :description="$t('VirtualCard.CardHolderPage.StateTipMessage')"
                    required
                    >
                    <template #label>
                        <label>
                            <sup style="color:red;font-size: 14px;vertical-align: bottom;">*</sup>
                            {{$t('VirtualCard.CardHolderPage.State')}}
                        </label>
                    </template>
                    </CInput>
                </CCol>
                <CCol md="6">
                    <CInput
                    feedback="Please provide a valid city."
                    id="validationCity"
                    invalid
                    required
                    >
                    <template #label>
                        <label>
                            <sup style="color:red;font-size: 14px;vertical-align: bottom;">*</sup>
                            {{$t('VirtualCard.CardHolderPage.City')}}
                        </label>
                    </template>
                    </CInput>
                </CCol>
                <CCol md="6">
                    <CInput
                    feedback="Please provide a valid city."
                    id="validationAddress"
                    invalid
                    required
                    >
                    <template #label>
                        <label>
                            <sup style="color:red;font-size: 14px;vertical-align: bottom;">*</sup>
                            {{$t('VirtualCard.CardHolderPage.Address')}}
                        </label>
                    </template>
                    </CInput>
                </CCol>
                <CCol md="6">
                    <CInput
                    feedback="Please provide a valid zip."
                    id="validationZip"
                    invalid
                    required
                    type="number"
                    >
                    <template #label>
                        <label>
                            <sup style="color:red;font-size: 14px;vertical-align: bottom;">*</sup>
                            {{$t('VirtualCard.CardHolderPage.PostalCode')}}
                        </label>
                    </template>
                    </CInput>
                </CCol>
            </CForm> -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelCreate('ruleCardHolderForm')">{{$t('VirtualCard.Cancel')}}</el-button>
                <el-button class="create-holder-btn" @click="submitCardHolderForm('ruleCardHolderForm')">{{$t('VirtualCard.Confirm')}}</el-button>
                
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { createdCardHolderApi, removeCardHolderApi, getCardHolderListApi } from '@/api/http.js'
export default {
    props: {
        useSelect: {
            type: Boolean
        }
    },
    data() {
        // const validateNumber = (rule, value, callback) => {
        //     console.log(rule)
        //     if (!/^\d*$/.test(value)) {
        //         callback(new Error('Invalid'));
        //     } else {
        //         callback();
        //     }
        // };
        const validateNumber = (rule, value, callback) => {
            console.log(rule)
            // 允许英文和数字
            if (!/^[a-zA-Z0-9]*$/.test(value)) {
                callback(new Error('Invalid'));
            } else {
                callback();
            }
        };
        return {
            dialogFormVisible: false,
            page_total: 0,
            page: 1,
            page_size: 10,
            items: [],
            cardHolderForm: {
                first_name: '',
                last_name: '',
                birthday: '',
                country: '',
                city: '',
                state: '',
                address: '',
                zip: null
            },
            cardHolderRulesForm: {
                first_name: [
                    { required: true, message: this.$t('VirtualCard.CardHolderPage.FirstName') + this.$t('VirtualCard.CardHolderPage.IsRequired'), trigger: 'blur' }
                ],
                last_name: [
                    { required: true, message: this.$t('VirtualCard.CardHolderPage.LastName') + this.$t('VirtualCard.CardHolderPage.IsRequired'), trigger: 'blur' }
                ],
                birthday: [
                    { required: true, message: this.$t('VirtualCard.CardHolderPage.Birthday') + this.$t('VirtualCard.CardHolderPage.IsRequired'), trigger: 'blur' }
                ],
                country: [
                    { required: true, message: this.$t('VirtualCard.CardHolderPage.Country') + this.$t('VirtualCard.CardHolderPage.IsRequired'), trigger: 'change' }
                ],
                state: [
                    { required: true, message: this.$t('VirtualCard.CardHolderPage.State') + this.$t('VirtualCard.CardHolderPage.IsRequired'), trigger: 'blur' }
                ],
                city: [
                    { required: true, message: this.$t('VirtualCard.CardHolderPage.City') + this.$t('VirtualCard.CardHolderPage.IsRequired'), trigger: 'blur' }
                ],
                address: [
                    { required: true, message: this.$t('VirtualCard.CardHolderPage.Address') + this.$t('VirtualCard.CardHolderPage.IsRequired'), trigger: 'blur' }
                ],
                zip: [
                    { required: true, message: this.$t('VirtualCard.CardHolderPage.PostalCode') + this.$t('VirtualCard.CardHolderPage.IsRequired'), trigger: 'blur' },
                    // { type: 'number'}
                    { required: true, validator: validateNumber, trigger: 'blur',message: 'Invalid' }
                ]
            },
            // pickerOptions: {
            //     // disabledDate(time) {
            //     // // 禁用1995年1月1日之前的日期
            //     // return time.getTime() < new Date('1995-01-01').getTime();
            //     // },
            //     // 设置默认显示的日期为1995-01-01
            //     defaultTime: '1995-01-01'
            // },
            errorCallBack: '',
            countryOption: ['UD','EN'],
            billingAdrOptions: ["CN", "HK", "UK", "MO", "TW", "AF", "AX", "AL", "DZ", "AS", "AD", "AO", "AI", "AQ", "AG", "AR", "AM", "AW", "AU", "AT", "AZ", "BS", "BH", "BD", "BB", "BY", "BE", "BZ", "BJ", "BM", "BT", "BO", "BQ", "BA", "BW", "BV", "BR", "IO", "BN", "BG", "BF", "BI", "CV", "KH", "CM", "CA", "KY", "CF", "TD", "CL", "CX", "CC", "CO", "KM", "CG", "CD", "CK", "CR", "CI", "HR", "CU", "CW", "CY", "CZ", "DK", "DJ", "DM", "DO", "EC", "EG", "SV", "GQ", "ER", "EE", "SZ", "ET", "FK", "FO", "FJ", "FI", "FR", "GF", "PF", "TF", "GA", "GM", "GE", "DE", "GH", "GI", "GR", "GL", "GD", "GP", "GU", "GT", "GG", "GN", "GW", "GY", "HT", "HM", "VA", "HN", "HU", "IS", "IN", "ID", "IR", "IQ", "IE", "IM", "IL", "IT", "JM", "JP", "JE", "JO", "KZ", "KE", "KI", "KP", "KR", "KW", "KG", "LA", "LV", "LB", "LS", "LR", "LY", "LI", "LT", "LU", "MG", "MW", "MY", "MV", "ML", "MT", "MH", "MQ", "MR", "MU", "YT", "MX", "FM", "MD", "MC", "MN", "ME", "MS", "MA", "MZ", "MM", "NA", "NR", "NP", "NL", "NC", "NZ", "NI", "NE", "NG", "NU", "NF", "MK", "MP", "NO", "OM", "PK", "PW", "PS", "PA", "PG", "PY", "PE", "PH", "PN", "PL", "PT", "PR", "QA", "RE", "RO", "RU", "RW", "BL", "SH", "KN", "LC", "MF", "PM", "VC", "WS", "SM", "ST", "SA", "SN", "RS", "SC", "SL", "SG", "SX", "SK", "SI", "SB", "SO", "ZA", "GS", "SS", "ES", "LK", "SD", "SR", "SJ", "SE", "CH", "SY", "TJ", "TZ", "TH", "TL", "TG", "TK", "TO", "TT", "TN", "TR", "TM", "TC", "TV", "UG", "UA", "AE", "GB", "UM", "US", "UY", "UZ", "VU", "VE", "VN", "VG", "VI", "WF", "EH", "YE", "ZM", "ZW"],
        }
    },
    computed: {
        sortBillingAdrOptions() {
            return this.billingAdrOptions.sort()
        },
    },
    created() {
        this.initCardHolderList()
    },
    methods: {
        // 当前页码改变
        handerPage(page) {
            console.log(page)
            this.page = page
            this.initCardHolderList()
        },
        // 选择持卡人
        handleSelectCardHolder(item) {
            this.$emit('onSelected', item)
        },
        // 当前总页数改变
        handleSizeChange(size) {
            console.log(size)
        },
        // 打开创建持卡人窗口
        openCardHolderDialog() {
            this.$message.warning(this.$t('VirtualCard.CardHolderPage.CreateCardholderBeforeTip'))
            // this.dialogFormVisible = true
        },
        // 持卡人数据
        initCardHolderList() {
            const data = {
                type: 'get_card_holder',
                uid: window.localStorage.getItem("uid"),
                page: this.page,
                page_size: this.page_size
            }
            getCardHolderListApi(data).then(res => {
                if(res.code == 200) {
                    this.items = res.data.data
                    this.page_total = Number(res.data.size)
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 移除持卡人API
        initRemoveCardHolder(holder_id) {
            const data = {
                type: 'remove_card_holder',
                uid: window.localStorage.getItem("uid"),
                holder_id: holder_id
            }
            removeCardHolderApi(data).then(res => {
                if(res.code == 200) {
                    // 重新请求列表数据
                    this.initCardHolderList()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 添加持卡人api
        initCreateCardHolder(formName) {
            const data = {
                type: 'add_card_holder',
                uid: window.localStorage.getItem("uid"),
                ...this.cardHolderForm
            }
            createdCardHolderApi(data).then(res => {
                if(res.code == 200) {
                    // 重新请求列表数据
                    this.initCardHolderList()
                    // 重置表单数据
                    this.$refs[formName].resetFields();
                    // 关闭窗口
                    this.dialogFormVisible = false
                    this.$message.success(res.message)
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 验证表单
        submitCardHolderForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.initCreateCardHolder(formName)
                    
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 取消关闭窗口
        cancelCreate(formName) {
            this.$refs[formName].resetFields();
            this.dialogFormVisible = false
        },
        validateDate(dateString) {
            if(dateString === undefined || dateString === '') {
                this.errorCallBack = ''
                return;
            }
            // 正则表达式验证格式
            const regex = /^\d{4}-\d{2}-\d{2}$/;
            if (regex.test(dateString)) {
                this.errorCallBack = ''
                return true;
            }
            else {
                this.errorCallBack = '无效'
                return false;
            }
            
            
        },
        // 移除
        handleRemoveCardHolder(item) {
            console.log("item", item)
            let that = this
            this.$confirm(this.$t('VirtualCard.CardHolderPage.DeleteCardHolderTipMessage'), '', {
                confirmButtonText: this.$t('VirtualCard.Confirm'),
                cancelButtonText: this.$t('VirtualCard.Cancel'),
                showClose: false,
                closeOnClickModal: false,
                type: 'warning'
            }).then(() => {
                console.log('确认')
                that.initRemoveCardHolder(item?.id)
            }).catch(() => {
                console.log('取消')
            })
        }
    }
}
</script>
<style>
    .create-card-holder-dialog {
        border-radius: 10px;
    }
</style>
<style scoped>
    .ch-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
    }
    .create-holder-btn {
        background-color: #00BEA4;
        color: #fff;
    }
    .mgr-16 {
        margin-bottom: 16px;
    }
    ::v-deep .el-input__inner {
      border-radius: 4px !important;
      /* border: 0; */
      /* padding-left: 0; */
      /* padding-right: 0; */
      /* box-shadow: none !important; */
      /* border-bottom: 1px solid #d9d9d9; */
      vertical-align: middle;
      border-color: #d8dbe0 !important;
      /* padding: 6px 12px !important; */
      /* line-height: 1.5 !important; */
      background-clip: padding-box;
      padding-top: 16.5px !important;
      padding-bottom: 16.5px !important;
    }
    ::v-deep .el-form-item__label {
        line-height: normal;
        margin: 0;
    }
</style>